import backend, {CLIENT_SUPPORT_API} from 'utils/backend/server/api_library';

const getCaregiverFeedback = (clientRn, caregiverRn) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/caregiver_feedback/client/${clientRn}/caregiver/${caregiverRn}`;
  return backend.get(url);
};

const generateCaregiverRecommendation = (clientRn, caregiverRn) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/client/${clientRn}/generate_cg_recommendation`;
  return backend.post(url, {caregiverRn});
};

const getEventFeedback = (eventFeedbackRn) => {
  const url = `${CLIENT_SUPPORT_API}/feedback/event/${eventFeedbackRn}`;
  return backend.get(url);
};

export default {
  getCaregiverFeedback,
  generateCaregiverRecommendation,
  getEventFeedback,
};
